import { type CarouselModalProps, CarouselModal as CommonCarouselModal } from '@monorepo/common';

function CarouselModal({ initShowIndex, isOpen, close, childrenArr }: CarouselModalProps) {
  return <CommonCarouselModal initShowIndex={initShowIndex} isOpen={isOpen} close={close} childrenArr={childrenArr} />;
}

export default CarouselModal;
